export default {"src":"/_next/static/media/LSCC.6c4873d2.svg","height":18,"width":18};